import { render, staticRenderFns } from "./AuthIllustrationLayout.vue?vue&type=template&id=7a85e5bd&"
import script from "./AuthIllustrationLayout.vue?vue&type=script&lang=js&"
export * from "./AuthIllustrationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a85e5bd')) {
      api.createRecord('7a85e5bd', component.options)
    } else {
      api.reload('7a85e5bd', component.options)
    }
    module.hot.accept("./AuthIllustrationLayout.vue?vue&type=template&id=7a85e5bd&", function () {
      api.rerender('7a85e5bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Layout/AuthIllustrationLayout.vue"
export default component.exports